export default function(candidate)
{
    return typeof candidate.length === "number";
}



// WEBPACK FOOTER //
// ./src/util/is-array.js